import axios from 'axios';
import store from '../../../store';
import { refreshToken } from '../../../actions/auth';

// ADR must never inherit core request/response interceptors: in particular,
// a reporting-only 401 must not revoke the shared InstaPM session.
const transport = axios.create({ timeout: 30000 });

transport.interceptors.response.use(response => {
  // Preserve token renewal during active ADR work. Only the existing Node/
  // Cognito refresh flow owns refresh tokens and decides login validity.
  // No ADR failure (including 401/403/5xx/offline) enters this path.
  try {
    const token = localStorage.getItem('token');
    const refresh = localStorage.getItem('refreshToken');
    const exp = token && JSON.parse(atob(token.split('.')[1])).exp;
    if (refresh && exp && exp * 1000 - Date.now() <= 10 * 60 * 1000) {
      store.dispatch(refreshToken(refresh));
    }
  } catch (_) { /* Malformed local tokens are rejected by the server. */ }
  return response;
});

export default transport;
